/**
 * Slaptažodžio stiprumo tikrinimas.
 * Reikalavimai: min 8 simboliai, bent viena didžioji raidė, mažoji raidė, skaičius ir simbolis.
 */

const PASSWORD_MIN_LENGTH = 8;

function hasUpperCaseLetter(str) {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code >= 65 && code <= 90) return true;
  }
  return false;
}

function hasLowerCaseLetter(str) {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code >= 97 && code <= 122) return true;
  }
  return false;
}

function hasDigit(str) {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code >= 48 && code <= 57) return true;
  }
  return false;
}

function hasSymbol(str) {
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    const isUpper = code >= 65 && code <= 90;
    const isLower = code >= 97 && code <= 122;
    const isDigit = code >= 48 && code <= 57;
    if (!isUpper && !isLower && !isDigit) return true;
  }
  return false;
}

/**
 * Grąžina kiekvieno reikalavimo atitikimą (UI indikatoriams).
 */
export function getPasswordStrength(password) {
  const pwd = typeof password === 'string' ? password : '';
  return {
    hasMinLength: pwd.length >= PASSWORD_MIN_LENGTH,
    hasUpperCase: hasUpperCaseLetter(pwd),
    hasLowerCase: hasLowerCaseLetter(pwd),
    hasNumber: hasDigit(pwd),
    hasSymbol: hasSymbol(pwd),
  };
}

/**
 * Grąžina true tik jei visi reikalavimai įvykdyti.
 */
export function isStrongPassword(password) {
  const s = getPasswordStrength(password);
  return s.hasMinLength && s.hasUpperCase && s.hasLowerCase && s.hasNumber && s.hasSymbol;
}

export { PASSWORD_MIN_LENGTH };
